import { HtmlIterator } from 'components/sharpr/html/htmlIterator/HtmlIteratorClass';

export function autolink(s) {
	return s
		.replace(
			/\b(https?:\/\/\S+?)([.,!'")?;\-]*(\s|$))/gi,
			'<a target="_blank" href="$1" rel="noreferrer noopener" class="autolink">$1</a>$2'
		)
		.replace(/([^\s@]+@[\w.-]+\.[\w]+)/g, '<a href="mailto:$1" class="autolink">$1</a>');
}

export function htmlLinkyFilter() {
	'ngInject';
	let iterator = new HtmlIterator(null, autolink);
	return html => iterator.map(html);
}
